import { useContext } from 'react'
import { PostingNoticeRequestContext } from 'contexts/posting_notice_request/PostingNoticeRequestContext'

const usePostingNoticeRequestContext = () => {
  const context = useContext(PostingNoticeRequestContext)

  if (!context)
    throw new Error(
      'PostingNoticeRequestContext must be placed within PostingNoticeRequestProvider'
    )

  return context
}

export default usePostingNoticeRequestContext
